import * as UIUtil from "/app/js/util/UI.js";
import * as Menu from "/app/js/common/Menu.js";
import * as Main from "/app/js/panel/Main.js";

/**
 * 단순조회 또는 간단한 기능을 하는 서브페이지 클래스
 * 상세한 기능이 있다면 별도 클래스를 구성해야한다.
 * @param menuKey
 * @returns {Promise<void>}
 */
export const open = async function (menuKey) {
    const parentKey = Menu.getParentKey(menuKey);
    const htmlUrl = `app/html/${document.documentElement.lang}/${parentKey}/${menuKey}.html`;
    // .headerWrap의 다음에 htmlUrl를 fetch하여 삽입한다.
    try {
        const response = await fetch(htmlUrl);
        const text = await response.text();
        const headerWrap = document.querySelector(".headerWrap");
        await headerWrap.insertAdjacentHTML('afterend', text);

        initEvt();
    } catch (error) {
        console.error('HTML 로딩 중 오류 발생:', error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리하도록 함
    }
}

function initEvt() {

    const homeElement = document.querySelector('.breadcrumb .home');

    if (homeElement) {
        homeElement.addEventListener('click', () => {
            Menu.openMenu('Main');
        });
    }
    //==================================//
    //            간단한 기능             //
    //==================================//
    //공통
    //브래드크럼
    const aboutUsElement = document.querySelector('.breadcrumb .greeting');
    if (aboutUsElement) {
        aboutUsElement.addEventListener('click', (e) => {
            Menu.openMenu('Greeting');
        });
    }

    const esgElement = document.querySelector('.breadcrumb .Esg');
    if (esgElement) {
        esgElement.addEventListener('click', (e) => {
            Menu.openMenu('Esg');
        });
    }

    const siSmElement = document.querySelector('.breadcrumb .SiSm');
    if (siSmElement) {
        siSmElement.addEventListener('click', (e) => {
            Menu.openMenu('SiSm');
        });
    }

    const productElement = document.querySelector('.breadcrumb .Engine');
    if (productElement) {
        productElement.addEventListener('click', (e) => {
            Menu.openMenu('Engine');
        });
    }

    const clientElement = document.querySelector('.breadcrumb .DomesticClients');
    if (clientElement) {
        clientElement.addEventListener('click', (e) => {
            Menu.openMenu('DomesticClients');
        });
    }

    const prCenterElement = document.querySelector('.breadcrumb .Notice');
    if (prCenterElement) {
        prCenterElement.addEventListener('click', (e) => {
            Menu.openMenu('Notice');
        });
    }


    //aboutus > History
    //회사소개서 다운로드

    //aboutus > Ci
    //파일 다운로드

}